import { useEffect, useRef } from 'react';
import { attachCipherCanvas } from '../utils/cipherCanvas';

// Involucro React del canvas "Il Cifrario".
//
// La prop `tema` non serve a scegliere i colori — quelli il canvas se li legge
// da solo dai token CSS — ma a sapere QUANDO rileggerli. Senza, il disegno
// restava quello del primo montaggio: il 2026-09-02 il tema scuro mostrava il
// canvas chiaro, con caratteri chiari e un alone bianco sotto un titolo
// altrettanto chiaro. repaint() era gia' scritta e semplicemente non veniva
// chiamata da nessuno.
export default function HeroCipherBackground({ tema }) {
  const ref = useRef(null);
  const agganciaRef = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const container = canvas && canvas.parentElement;
    if (!container) return undefined;
    const stacca = attachCipherCanvas(container, canvas);
    agganciaRef.current = stacca;
    return () => { agganciaRef.current = null; stacca(); };
  }, []);

  // Al cambio tema si ridisegna e basta: repaint() riusa le dimensioni
  // correnti e non tocca canvas.width/height, che e' l'unica cosa capace di
  // riaprire il circolo vizioso della crescita.
  useEffect(() => {
    const stacca = agganciaRef.current;
    if (stacca && stacca.repaint) stacca.repaint();
  }, [tema]);

  return <canvas ref={ref} className="cps-cipher-bg" aria-hidden="true" />;
}
